import React from 'react';
import cx from 'classnames';

import TextBlock, { TextBlockProps } from '../TextBlock';
import Link, { LinkVariants } from '../Link';
import CheckmarkListItem, {
  CheckmarkListItemProps,
} from '../CheckmarkListItem';

import { Body1 } from '../Typography';

import styles from './index.module.scss';

export enum BackgroundColor {
  GRADIENT = 'gradient',
  RED = 'red',
  GREEN = 'green',
  WHITE = 'white',
}

const backgroundColorMap: Record<BackgroundColor, string> = {
  [BackgroundColor.GRADIENT]:
    'linear-gradient(90deg, rgba(85, 68, 148, 1) 0%, rgba(255, 97, 69, 1) 100%)',
  [BackgroundColor.RED]: '#c8585f',
  [BackgroundColor.GREEN]: '#7C9179',
  [BackgroundColor.WHITE]: '#FFFFFF',
};

export interface BannerStyleCardProps {
  textBlockItems: TextBlockProps;
  listItems?: CheckmarkListItemProps[];
  description?: string;
  buttonUrl?: string;
  buttonText?: string;
  backgroundColor?: BackgroundColor;
}

const BannerStyleCard: React.FC<BannerStyleCardProps> = ({
  textBlockItems,
  listItems,
  description,
  buttonUrl,
  buttonText,
  backgroundColor = BackgroundColor.GRADIENT,
}) => {
  const backgroundColorValue = backgroundColorMap[backgroundColor];
  const isBackgroundWhite =
    backgroundColorValue === backgroundColorMap[BackgroundColor.WHITE];
  const isBackgroundRed =
    backgroundColorValue === backgroundColorMap[BackgroundColor.RED];
  const isBackgroundGreen =
    backgroundColorValue === backgroundColorMap[BackgroundColor.GREEN];

  return (
    <div
      className={cx(styles.wrapper, { [styles.textWhite]: !isBackgroundWhite })}
      style={{ background: backgroundColorValue }}
    >
      <TextBlock
        className={cx({
          [styles.textWhite]: !isBackgroundWhite,
          [styles.textBlock]: true,
        })}
        priceClassName={cx({ [styles.priceWithOpacity]: !isBackgroundWhite })}
        {...textBlockItems}
      />

      <div className={styles.listAndDescriptionWrapper}>
        {listItems && listItems.length > 0 && (
          <ul className={styles.listWrapper}>
            {listItems.map((item) => (
              <CheckmarkListItem
                key={item.text}
                text={item.text}
                isCheckmarkWhite={!isBackgroundWhite}
              />
            ))}
          </ul>
        )}

        {description && (
          <Body1
            className={cx(styles.description, {
              [styles.textWhite]: !isBackgroundWhite,
              [styles.noMarginTop]: !listItems,
            })}
          >
            {description}
          </Body1>
        )}

        {buttonText && buttonUrl && (
          <Link
            className={styles.button}
            textClassName={cx({
              [styles.buttonTextRed]: isBackgroundRed,
              [styles.buttonTextGreen]: isBackgroundGreen,
            })}
            url={buttonUrl}
            variant={
              isBackgroundWhite ? LinkVariants.PRIMARY : LinkVariants.ELEVATED
            }
          >
            {buttonText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default BannerStyleCard;
